import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("izzo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Sessione scaduta (3 ore): su 401 con un token attivo, esci e torna al login.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const hadToken = !!localStorage.getItem("izzo_token");
    const isAuthAttempt = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/activate");
    if (status === 401 && hadToken && !isAuthAttempt) {
      localStorage.removeItem("izzo_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign("/login?scaduta=1");
      }
    }
    return Promise.reject(error);
  }
);

// SEC-003: download protetti con token monouso a breve scadenza (mai il JWT di sessione in URL)
export async function secureFileUrl(path) {
  const clean = path.startsWith("/") ? path : `/${path}`;
  const { data } = await api.post("/download-token", { resource: `/api${clean.split("?")[0]}` });
  return `${API}${clean}${clean.includes("?") ? "&" : "?"}dt=${data.dt}`;
}

export async function openSecureFile(path) {
  const w = window.open("about:blank", "_blank");
  try {
    const url = await secureFileUrl(path);
    if (w && !w.closed) w.location.replace(url);
    else window.open(url, "_blank");
  } catch (e) {
    if (w) w.close();
    throw e;
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Iter123k196 · Testo errore più informativo per il login: distingue problemi di rete, 401
// (credenziali errate), 403 (account non attivato/sospeso), 429 (lockout) e 5xx (bug server).
// Prima tutto cadeva su "Si è verificato un errore. Riprova." impedendo di capire il motivo.
export function formatLoginError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (detail) return formatApiError(detail);
  if (!err?.response) {
    return "Impossibile raggiungere il server. Verifica la connessione e riprova.";
  }
  if (status === 401) return "Credenziali non corrette. Controlla email/ID di accesso e password.";
  if (status === 403) return "Account non attivato o sospeso. Usa 'Prima attivazione account' o contatta lo Studio.";
  if (status === 429) return "Troppi tentativi falliti. Attendi qualche minuto e riprova.";
  if (status >= 500) return `Errore temporaneo del server (${status}). Riprova tra qualche istante. Se persiste, contatta l'assistenza.`;
  return `Si è verificato un errore (status ${status || "?"}). Riprova.`;
}

// Iter122at · marca una sezione come "vista" per azzerare il badge sidebar del condòmino.
// Iter122cz · ritorna la risposta backend che include `previous` (last_seen prima
// dell'aggiornamento) usato per distinguere elementi già letti da quelli nuovi.
export function markSectionSeen(section) {
  return api.post(`/me/last-seen/${section}`).then((r) => r.data).catch(() => ({}));
}

export default api;
